var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"page-container",attrs:{"fluid":""}},[_c('BrandCheckout',{attrs:{"combos":_vm.combos,"discount":_vm.discount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }